import { render, staticRenderFns } from "./TheLayoutFull.vue?vue&type=template&id=3c8e2797&"
import script from "./TheLayoutFull.vue?vue&type=script&lang=js&"
export * from "./TheLayoutFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports